<template>
  <div
    class="overlay grid-stack-center show"
    :class="[
      modalWidth === 'fullscreen' ? 'overlay--fullscreen overlay--close-absolute' : '',
      fullscreenEdgeToEdge === true ? 'fullscreen-edge-to-edge' : '',
      fullscreenEdgeToEdgeMobile === true ? 'fullscreen-edge-to-edge-mobile overlay--close-absolute' : '',
    ]"
    :style="{ zIndex: zIndex }"
    @mousedown="onBackdropMouseDown"
  >
    <div
      class="overlay__content overlay__modal"
      :class="[modalClass, modalWidth]"
      role="dialog"
      aria-modal="true"
      :aria-label="ariaLabel || title || 'Modal'"
      @mousedown.stop
    >
      <div class="overlay__close" v-if="showCloseButton" @click="emitClose">
        <slot name="close">
          <button type="button">
            <IconModalClose />
          </button>
        </slot>
      </div>

      <div class="overlay__header" v-if="title || $slots.header">
        <slot name="header">
          <h2 class="fk-modal-header mb8" v-if="title">{{ title }}</h2>
        </slot>
      </div>

      <div class="fk-modal-content">
        <slot></slot>
      </div>

      <div class="actions buttons-links layout-buttons mt24" v-if="$slots.actions" :class="actionsClass">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import IconModalClose from '@assets/js/vue-components/IconModalClose.vue';

export default {
  name: 'BaseModal',

  components: {
    IconModalClose,
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    ariaLabel: {
      type: String,
      default: ''
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnEsc: {
      type: Boolean,
      default: true
    },
    closeOnBackdrop: {
      type: Boolean,
      default: true
    },
    preventClose: {
      type: Boolean,
      default: false
    },
    modalClass: {
      type: String,
      default: ''
    },
    // Modal width can be '', 'medium', 'wide', 'extra-wide', 'fullscreen'
    modalWidth: {
      type: String,
      default: ''
    },
    // Make the route report modal go edge-to-edge when < 1024px
    fullscreenEdgeToEdge: {
      type: Boolean,
      default: false
    },
    // Used in the ExtraRoutesDateModal.vue
    fullscreenEdgeToEdgeMobile: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: 1000
    },
    actionsClass: {
      type: String,
      default: ''
    }
  },

  emits: ['close'],

  computed: {
    showCloseButton() {
      if (this.preventClose) {
        return false;
      }
      return this.showClose;
    }
  },

  mounted() {
    this.onKeyDown = (e) => {
      if (!this.closeOnEsc) return
      if (e.key === 'Escape') {
        this.emitClose()
      }
    }

    window.addEventListener('keydown', this.onKeyDown)
  },

  beforeUnmount() {
    window.removeEventListener('keydown', this.onKeyDown)
  },

  methods: {
    emitClose() {
      // The preventClose prop is used to prevent the modal from closing, for example while the "buy_gifts" AJAX call is in progress
      if (this.preventClose) return;
      this.$emit('close')
    },

    onBackdropMouseDown() {
      if (!this.closeOnBackdrop) return
      this.emitClose()
    }
  }
}
</script>

<style lang="scss">
.actions {

  &.space-between {
    justify-content: space-between;
  }
}
</style>
